import { CommonLogger } from '@jewelutions/core-common-logic'

export const Logger = CommonLogger.logger.child({
    module: 'ui-backoffice'
});